import { createFileRoute } from "@tanstack/react-router";
import { Require } from "../features/require";
import { BillingSettingsPage } from "../features/settings/billing-settings-page";

/** More > Billing settings (P4-T23). */
export const Route = createFileRoute("/more/billing")({ component: Page });

function Page() {
	return (
		<Require permission="settings.manage">
			<BillingSettingsPage />
		</Require>
	);
}
